import AdminUserTypes from './constants'

export const loadUsers = (formData) => {
  return {
    type: AdminUserTypes.LOAD_USERS,
    payload: formData
  }
}
export const setUsers = (data) => {
  return {
    type: AdminUserTypes.SET_USERS,
    payload: data
  }
}
export const loadLuongCoBan = (formData) => {
  return {
    type: AdminUserTypes.LOAD_LUONG_CO_BAN,
    payload: formData
  }
}
export const setLuongCoBan = (data) => {
  return {
    type: AdminUserTypes.SET_LUONG_CO_BAN,
    payload: data
  }
}
export const adminUserRemoveItemRequest = function adminUserRemoveItemRequest (requestData) {  
  return {
    type: AdminUserTypes.ITEM_REMOVE_REQUESTING,
    payload: requestData
  }
}

export const adminUserItemRemoveSuccess = function adminUserItemRemoveSuccess (message) {  
  return {
    type: AdminUserTypes.ITEM_REMOVE_SUCCESS,
    payload: message
  }
}

export const adminUserItemRemoveError = function adminUserItemRemoveError (error) {  
  return {
    type: AdminUserTypes.ITEM_REMOVE_ERROR,
    payload: error
  }
}

export const adminUserSetDataForUser = (data) => {  
  return {
    type: AdminUserTypes.SET_DATA_TO_USER,
    payload: data
  }
}

export const adminUserSetMessage = function adminUserSetMessage (message) {  
  return {
    type: AdminUserTypes.SET_MESSAGE,
    payload: message
  }
}

export const resetError = () => {  
  return {
    type: AdminUserTypes.RESET_ERROR,
  }
}

export const adminUserSetError = (error) => {  
  return {
    type: AdminUserTypes.SET_ERROR,
    payload: error
  }
}

export const adminUserSetErrors = (error) => {  
  return {
    type: AdminUserTypes.SET_FORM_MESSAGES,
    payload: error
  }
}

export const adminUserListRequest = function adminUserListRequest (formData) {  
  return {
    type: AdminUserTypes.LIST_REQUESTING,
    payload: formData
  }
}

export const adminUserListSuccess = function adminUserListSuccess (data) {  
  return {
    type: AdminUserTypes.LIST_SUCCESS,
    data
  }
}

export const adminUserListError = function adminUserListError (error) {  
  return {
    type: AdminUserTypes.LIST_ERROR,
    error
  }
}

export const adminUserItemRequest = function adminUserItemRequest (formData, callback) {  
  return {
    type: AdminUserTypes.ITEM_REQUESTING,
    payload: formData
  }
}

export const adminUserItemSuccess = function adminUserItemSuccess (data) {  

  return {
    type: AdminUserTypes.ITEM_SUCCESS,
    data : data
  }
}
export const adminUserSetDataForItem = function adminUserSetDataForItem (name, data) { 
  return {
    type: AdminUserTypes.SET_DATA_TO_PROPS,
    payload: {name, data}
  }
}

export const adminUserItemError = function adminUserItemError (error) {  
  return {
    type: AdminUserTypes.ITEM_ERROR,
    error
  }
}
export const adminUserItemAddRequest = function adminUserItemAddRequest (formData) {  
  return {
    type: AdminUserTypes.ITEM_ADD_REQUESTING,
    payload: formData
  }
}

export const adminUserItemAddSuccess = function adminUserItemAddSuccess (responseData) {  
  return {
    type: AdminUserTypes.ITEM_ADD_SUCCESS,
    data: responseData.data,
    message: responseData.message
  }
}

export const adminUserItemAddError = function adminUserItemAddError (error) {  
  return {
    type: AdminUserTypes.ITEM_ADD_ERROR,
    error
  }
}
export const adminUserItemUpdateRequest = function adminUserItemUpdateRequest (formData) {  
  return {
    type: AdminUserTypes.ITEM_UPDATE_REQUESTING,
    payload: formData
  }
}

export const adminUserItemUpdateSuccess = function adminUserItemUpdateSuccess (responseData) {  
  return {
    type: AdminUserTypes.ITEM_UPDATE_SUCCESS,
    data: responseData.data,
    message: responseData.message
  }
}

export const adminUserItemUpdateError = function adminUserItemUpdateError (error) {  
  return {
    type: AdminUserTypes.ITEM_UPDATE_ERROR,
    error
  }
}

export const adminUserResetData = function adminUserResetData () {  
  return {
    type: AdminUserTypes.RESET_DATA,
  }
}


// WEBPACK FOOTER //
// ./src/views/Admin/AdminUser/actions.js